import React from 'react';
import { Link } from 'react-router-dom';

const CtaSection = () => {
    return (
        <section style={styles.ctaSection}>
            <div style={styles.container}>
                <div style={styles.ctaBox}>
                    <h2 style={styles.ctaTitle}>Experience the Dee Cee Difference</h2>
                    <p style={styles.ctaText}>
                        Ready to elevate your building with our innovative solutions?
                        <br/>Contact our team today for a personalized consultation.
                    </p>
                    <div style={styles.ctaButtons}>
                        <Link to="/contact" style={styles.ctaPrimaryButton}>Contact Us</Link>
                        <Link to="/products" style={styles.ctaSecondaryButton}>Browse Products</Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

const styles = {
    ctaSection: {
        padding: '90px 0',
        backgroundColor: '#ffffff',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
    },
    ctaBox: {
        backgroundColor: '#f8fafc',
        padding: '60px',
        borderRadius: '15px',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e5e7eb',
    },
    ctaTitle: {
        fontSize: '2.2rem',
        fontWeight: '800',
        marginBottom: '20px',
        color: '#2c3e50',
    },
    ctaText: {
        fontSize: '1.2rem',
        lineHeight: '1.8',
        color: '#64748b',
        marginBottom: '40px',
    },
    ctaButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        flexWrap: 'wrap',
    },
    ctaPrimaryButton: {
        backgroundColor: '#163ba2',
        color: 'white',
        padding: '15px 35px',
        borderRadius: '30px',
        fontWeight: '600',
        fontSize: '1.1rem',
        textDecoration: 'none',
        boxShadow: '0 10px 25px rgba(22, 59, 162, 0.25)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        display: 'inline-block',
    },
    ctaSecondaryButton: {
        backgroundColor: 'transparent',
        color: '#163ba2',
        padding: '15px 35px',
        borderRadius: '30px',
        fontWeight: '600',
        fontSize: '1.1rem',
        textDecoration: 'none',
        border: '2px solid #163ba2',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        display: 'inline-block',
    },
    '@media (max-width: 992px)': {
        ctaBox: {
            padding: '40px 30px',
        },
        ctaTitle: {
            fontSize: '2rem',
        },
    },
    '@media (max-width: 820px)': {
        ctaSection: {
            padding: '70px 0',
        },
        ctaTitle: {
            fontSize: '1.8rem',
        },
    },
    '@media (max-width: 576px)': {
        ctaSection: {
            padding: '50px 0',
        },
        ctaBox: {
            padding: '30px 20px',
        },
        ctaTitle: {
            fontSize: '1.6rem',
        },
    }
};

export default CtaSection;